import React from 'react';
import classNames from 'classnames';
import { SectionProps } from '../utils/SectionProps';

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

const NotFound = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  invertMobile,
  invertDesktop,
  alignTop,
  imageFill,
  ...props
}) => {

  const outerClasses = classNames(
    'features-split section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-split-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const splitClasses = classNames(
    'split-wrap',
    invertMobile && 'invert-mobile',
    invertDesktop && 'invert-desktop',
    alignTop && 'align-top'
  );

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <title>MergeURL - Page Not Found</title>
      <div className="container">
        <div className={innerClasses}>
          <div className={splitClasses}>
            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                <h1 className="mt-0 mb-16 reveal-from-bottom" data-reveal-delay="200">
                  The page you’re looking for <span className="text-color-primary">can’t be found</span>
                </h1>
                <div className="container-xs">
                <p className="mt-16 mb-32 reveal-from-bottom" data-reveal-delay="400">
                  We think you've followed a broken link, and you're lost. Click <a href="/"><span className="text-color-primary"><b>here</b></span></a> to go to the home page of MergeURL.
                </p>
                </div>
              </div>
              <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">
                <img
                  src={require('./../assets/images/feature-split-image-05.png')}
                  alt="Features split 05"
                  style={{ width: 450, height: 450 }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

NotFound.propTypes = propTypes;
NotFound.defaultProps = defaultProps;

export default NotFound;
